import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import {Router, NavigationExtras, ActivatedRoute} from '@angular/router';
import { FormControl, FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';

import { ProjectmanagementService } from '../../service/projectmanagement.service';
import { Project, Partner, Country, User } from '../../model/project.model';
import * as projectforms from '../../forms/projectmanagement.form';
import { MyErrorHandler } from '../../errorhandler/errorhandler';

import { Subject } from 'rxjs';

import { TranslateService } from '@ngx-translate/core';

import { CtlPartnerForm } from '../../../../../tools/src/lib/forms/partner/CtlPartnerForm';
import { CtlUserForm } from '../../forms/user/CtlUserForm';

import { CtlProjectForm } from '../../forms/project/ctl.project.form.component';
import { Dialog } from '@eds/vanilla';

import * as languageConfig from '../../../../../../src/assets/i18n/configuration/configuration.json';

@Component({
  selector: 'app-addnewproject',
  templateUrl: './addnewproject.component.html',
  styleUrls: ['./addnewproject.component.css'],
  providers: [ProjectmanagementService]
})
export class AddnewprojectComponent implements OnInit {
  @ViewChild(CtlProjectForm)
    public projForm: CtlProjectForm;

  @ViewChild(CtlPartnerForm)
    public partnerForm: CtlPartnerForm;

  @ViewChild(CtlUserForm)
    public userForm: CtlUserForm;

  toChild: Subject<any> = new Subject();

  projectForm = projectforms.projectForm;

  projectFormData: FormGroup;

  partnerList: any[] = [];
  leadPartner: any;
  countryList: any[] = [];
  partnerUserList: any[];
  myrole: string;

  btnnext = false;

  btnTextAdd = 'Add';
  btnStatusAdd = true;
  btnTextCancel = 'Cancel';
  error = '';
  message = '';

  completeDisabled = false;

  step = 1;
  loaded = false;

  data: any;
  adminList: User[];

  step1Flag = false;
  detailMessage1;
  detailMessage2;

  projectData: Project;
  addPartnerData: Partner;
  noResultIndicator = true;
  currentSteps = 1;
  newPartner;
  titleMessage; // confirm message for alert modal
  subTitleMessage; // confirm message for alert modal
  detailMessage; // confirm message for alert modal
  detailMessageLine1;
  wizardSteps = [
    'New project details',
    'Review & complete'
  ];

  wizardEditSteps = [
    'Edit project details',
    'Review & complete'
  ];
partnerTitle:"";
  project_id: string;
  sub;
  languageConfiguration: any;
  textDir:any;
  constructor(
    public translate: TranslateService,
    private addnewprojectService: ProjectmanagementService,
    private router: Router,
    private route: ActivatedRoute) {
      this.languageConfiguration = (languageConfig as any).default;
      translate.addLangs([this.languageConfiguration.languages]);
      translate.setDefaultLang(this.languageConfiguration.defaultLang);
      let selectedLang = sessionStorage.getItem('selectedLang');
      this.textDir = sessionStorage.getItem('textDir');
      this.partnerTitle = this.translate.instant('Add new lead partner');
      let langRegExp = new RegExp(this.languageConfiguration.languageRegexp);
      if(selectedLang){
        translate.use(selectedLang.match(langRegExp) ? selectedLang : this.languageConfiguration.defaultLang);  
      } else {
        const browserLang = translate.getBrowserLang();                  
        translate.use(browserLang.match(langRegExp) ? browserLang : this.languageConfiguration.defaultLang);  
      }  
    }

  ngOnInit(): void {
    if (window.localStorage.getItem('loginInfoObj') == null) {
      console.log('token info missing');
      this.router.navigate(['/login']);
    }
    this.initProject();
    this.projectForm.reset();
  }

  initProject() {
    this.loaded = false;
    this.addnewprojectService.initAddProj().subscribe(
      data => {
        this.countryList = data[0].slice(0);
        this.partnerList = data[1].slice(0);
      }
    );
    this.loaded = true;
  }

  openDialogModal(id){
    const dialogDOM = document.querySelector('#' + id) as HTMLElement;
    const dialog = new Dialog(dialogDOM);
    dialog.init();
    dialog.show();
  }

  closeDialogModal(id){
    const dialogDOM = document.querySelector('#' + id) as HTMLElement;
    const dialog = new Dialog(dialogDOM);
    dialog.init();
    dialog.hide();
  }

  projectFormChange(flag: boolean) {
    if (this.projectForm.dirty || this.projectForm.touched) {
      if (this.currentSteps === 1) {
        if (this.projectForm.get('name').valid &&
          this.projectForm.get('description').valid &&
          this.projectForm.get('lpartner').valid &&
          this.projectForm.get('country').valid &&
          this.projectForm.get('admin.first_name').valid &&
          this.projectForm.get('admin.last_name').valid &&
          this.projectForm.get('admin.email').valid) {
          this.btnnext = true;
        }else{
          this.btnnext = false;
        }
      } else if (this.currentSteps === 2) {
        if (this.projectForm.get('name').valid &&
          this.projectForm.get('description').valid &&
          this.projectForm.get('lpartner').valid &&
          this.projectForm.get('country').valid &&
          this.projectForm.get('admins.padmin').valid
        ) {
          this.btnnext = true;
        }else{
          this.btnnext = false;
        }
      }
    }
    //alert("formChange >>"+this.btnnext)
  }

  nextStep() {
    this.projectForm.markAsDirty();
    if (this.currentSteps === 1) {
      if (this.projectForm.get('name').invalid ||
        this.projectForm.get('description').invalid ||
        this.projectForm.get('lpartner').invalid ||
        this.projectForm.get('country').invalid ||
        this.projectForm.get('admin.first_name').invalid
      ) {
        this.btnnext = false;
      } else {
        this.currentSteps++;
        this.btnnext = false;
      }
    } else if (this.currentSteps === 2) {
      if (this.projectForm.get('name').invalid ||
        this.projectForm.get('description').invalid ||
        this.projectForm.get('lpartner').invalid ||
        this.projectForm.get('country').invalid ||
        this.projectForm.get('admins.padmin').invalid
      ) {
        this.btnnext = false;
      } else {
        this.currentSteps++;
        this.btnnext = false;
      }
    }
    //alert("nextStep >>> "+this.btnnext)
  }

  backStep() {
    if (this.currentSteps !== 1) {
      this.currentSteps = 1;
      if (this.projectForm.get('name').invalid ||
        this.projectForm.get('description').invalid ||
        this.projectForm.get('lpartner').invalid ||
        this.projectForm.get('country').invalid
      ) {
        this.btnnext = false;
      } else {
        this.btnnext = true;
      }
    }
  }

  onAddProjectFormSubmit() {
    this.completeDisabled = true;
    if (this.project_id) {
      this.updateProject();
    } else {
      this.addProject();
    }
  }

  addProject() {
     const data = this.projectForm.value;
     data.country = this.projectForm.get('country').value._id;
     data.lpartner = this.projectForm.get('lpartner').value._id || this.partnerForm.newPartner;

     if (!data.logo) {
       delete data.logo;
     }

     delete data.partner;
     delete data.partners;
     delete data.admins;
     delete data.ladmin;

     this.addnewprojectService.create(JSON.stringify(data)).subscribe(
       (response) => {
         window.localStorage.setItem('projectaddsuccess', response.project_id);
         window.localStorage.setItem('projectName', this.projectForm.get('name').value);
         window.localStorage.setItem('projectCountryName', this.projectForm.get('country').value.name);
         this.router.navigate(['/projectmanagement']);
       },
       (err) => {
          console.log('ERROR: ' + err);
          const errorHandlerObj = new MyErrorHandler();
          const errorHandler = errorHandlerObj.handleError(err);
          if (errorHandler.isSssionExpired) {
            this.router.navigate(['/login']);
            return true;
          }else{
            this.openServerErrorDialog();
          }
       },
       () => {
        // console.log('COMPLETED');
       }
     );
   }

   updateProject() {

    if (!this.project_id) {
      return false;
    }
    console.log('Project Form Data ' + JSON.stringify(this.projectForm.value));
    // redirect on success
    const data = this.projectForm.value;
    data.partners = [];
    data.country = this.projectForm.get('country').value._id;
    data.admins = [];

    if (!data.logo) {
      delete data.logo;
    }

    delete data.partner;

    this.projectForm.get('partners').value.forEach(element => {
      data.partners.push(element._id);
    });

    if (this.projectForm.get('admins.padmin').value) {
      data.admins.push(this.projectForm.get('admins.padmin').value._id);
    }
    if (this.projectForm.get('admins.sadmin').value) {
      data.admins.push(this.projectForm.get('admins.sadmin').value._id);
    }
    if (this.projectForm.get('admins.cadmin').value) {
      data.admins.push(this.projectForm.get('admins.cadmin').value._id);
    }
    this.addnewprojectService.update(this.project_id, JSON.stringify(data)).subscribe(
      (response) => {
        console.log(' Full Response: ' + JSON.stringify(response));
        const navigationExtras: NavigationExtras = {
          queryParams: {
            success: true
          }
        };
        this.router.navigate(['/projectmanagement'], navigationExtras);
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }else{
          this.openServerErrorDialog();
        }
      },
      () => {
        console.log('COMPLETED');
      }

    );
  }

  alertOK() {
    this.router.navigate(['/projectmanagement']);
  }

  getProjectData(data) {
    this.addnewprojectService.search(data).subscribe(
      (response) => {
        console.log(' Full Response: ' + JSON.stringify(response));
        this.projectData = response[0];
      },
      (err) => {
        console.log('ERROR: ' + err);
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        console.log('COMPLETED');
      }
    );
  }

  partnerListFormatter(item: any): string {
    if (item) {
      return `${item['name']}`;
    }
    return;
  }

  partnerValueFormatter(item: any): string {
    if (item) {
      return `${item['name']}`;
    }
    return;
  }

  openPartnerModal() {
    this.partnerForm.action = '';
    this.partnerForm.message = '';
    this.error = '';
    this.message = '';
    if (this.partnerForm.partnerForm.invalid) {
      this.btnStatusAdd = true;
      this.btnTextAdd = this.translate.instant('Add');
      this.btnTextCancel = 'Cancel';
    } else {
      this.btnStatusAdd = false;
    }
    this.openDialogModal('partnerModal');
  }

  partnerFormChange(flag) {
     if (flag && this.partnerForm.partnerForm.invalid) {
       this.btnStatusAdd = true;
     } else {
       this.btnStatusAdd = false;
     }
 
     if (this.partnerForm.action) {
       if (this.partnerForm.action === 'failure') {
         this.error = 'error';
       }
       this.message = this.partnerForm.message;
       this.btnTextCancel = 'Close';
       this.btnTextAdd = '';
       if (this.project_id) {
         this.getProjectData(this.project_id);
         this.getPartnerList(this.project_id); 
       }
     }
   }
  addPartner() {
    const myPartner = this.partnerForm.partnerForm.value;
    this.partnerForm.onPartnerFormSubmit();
    this.initProject();

    if (myPartner) {
      this.leadPartner = myPartner;
      myPartner._id = this.partnerForm.newPartner;
      this.leadPartner._id = this.partnerForm.newPartner;
      this.projectForm.get('lpartner').patchValue( myPartner);
    }
    // window.localStorage.removeItem('newPartner');

    this.toChild.next('RefreshPartner');

    this.titleMessage = this.translate.instant('New')+" "+ this.translate.instant('Partner')+" "+this.translate.instant('added');
    this.subTitleMessage = myPartner.name;
    this.closeDialogModal('partnerModal');
    this.openDialogModal('successModal');
  }

   cancelPartner() {
     // alert('cancel clicked');
     this.partnerForm.resetForm();
     this.getPartnerList({});
   }

   getPartnerList(data) {
     //
     this.addnewprojectService.listPartner(data).subscribe(
       (response) => {
         this.partnerList = response;
         window.localStorage.setItem('partnerListObj', JSON.stringify(response));
       },
       (err) => {
         const errorHandlerObj = new MyErrorHandler();
         const errorHandler = errorHandlerObj.handleError(err);
         if (errorHandler.isSssionExpired) {
           this.router.navigate(['/login']);
           return true;
         }
       },
       () => {
         console.log('COMPLETED');
       }
     );
   }
  getCountryList() {
    this.addnewprojectService.listCountry().subscribe(
      (response) => {
        this.countryList = response;
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        console.log('COMPLETED');
      }
    );
  }
  getAdminList(data) {
    this.addnewprojectService.listAdmin(data).subscribe(
      (response) => {
        this.adminList = response;
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        console.log('COMPLETED');
      }
    );
  }
  openAdminModal(role: string) {
    this.myrole = role;
    this.btnTextAdd = this.translate.instant('Add');
    this.btnTextCancel = 'Cancel';

    this.userForm.resetForm();
    this.userForm.action = '';
    this.userForm.message = '';
    this.error = '';
    this.message = '';

    this.userForm.myrole = role;
    this.userForm.myRoleName = this.userForm.getRole(role);

    if (this.userForm.userForm.invalid) {
      this.btnStatusAdd = true;
    } else {
      this.btnStatusAdd = false;
    }
    // jQuery('#adminModal').modal('show');
  }

  adminFormChange(flag) {
    if (flag && this.userForm.userForm.invalid && this.userForm.userForm.hasError('required')) {
      this.btnStatusAdd = true;
    } else {
      this.btnStatusAdd = false;
    }

    if (this.userForm.action) {
      if (this.userForm.action === 'failure') {
        this.error = 'error';
      }
      this.message = this.userForm.message;
      this.btnTextCancel = 'Close';
      this.btnTextAdd = '';
      if (this.project_id) {
        this.getProjectData(this.project_id);
      }
    }
  }

  getProjectAdminList() {
    const data = {
      filter_by: 'partner',
      filter_value: this.projectForm.get('partner').value._id
    };

    this.addnewprojectService.listAdmin(data).subscribe(
      (response) => {
        console.log('list admin: ' + JSON.stringify(response));
        this.partnerUserList = response;
      },
      (err) => {
        const errorHandlerObj = new MyErrorHandler();
        const errorHandler = errorHandlerObj.handleError(err);
        if (errorHandler.isSssionExpired) {
          this.router.navigate(['/login']);
          return true;
        }
      },
      () => {
        console.log('list admin - complete');
      }
    );
  }

  addAdmin() {
    // alert('add clicked');
    this.userForm.onUserFormSubmit();
    this.getProjectAdminList();
    this.projectForm.get('admins.padmin').patchValue(this.userForm.userForm.get('first_name').value);
    //
  }

  openServerErrorDialog(){
    this.titleMessage = this.translate.instant('Server or network error');
    this.detailMessage1 = this.translate.instant('A server or network error has occurred. Please try again later.');
    this.detailMessage2 = this.translate.instant('If this error persists contact your system administrator.');
    this.openDialogModal('errorModal');
  }

}
